export const iconFontAwesomeDisasterCrisisHelmetUn = (
	<i className="fa-solid fa-helmet-un"></i>
);
